<template>
  <div>
    <h2 class="uppercase mt-24 border-b border-chocolate-academy-600 text-lg">
      {{$t('password.accessData')}}
    </h2>
    <div class="flex justify-between items-center mb-20">
      <material-label class="mt-6 mr-6 w-full" name="Email" :value="user.email" />
       <button
        class="text-b2c-grey-400 hover:text-b2c-red-300 transform rounded p-1 mt-10
          flex items-center justify-end text-sm w-full"
        @click="changePassword=!changePassword">
          <span class="px-2"> {{$t('password.changePassword')}}</span>
          <dropdown-arrow />
        </button>
    </div>

    <div v-if="changePassword" class="w-3/4 md:w-1/2 mb-20">
      <material-input class="mt-10 pt-1" type="password" :name="$t('password.old')"
        v-model="updatePassword.oldPassword" />
      <material-input class="mt-4 pt-1" type="password" :name="$t('password.new')"
        v-model="updatePassword.newPassword" />
      <material-input class="mt-4 pt-1" type="password" :name="$t('password.newConfirm')"
        v-model="updatePassword.confirmNewPassword" />
      <button
        class="hidden md:block shadow-md text-b2c-grey-400 hover:bg-b2c-red-300 hover:text-white
        rounded-md p-2 px-3 mt-10"
        @click="saveNewPassword"
        :class="isLoading ? 'loader' : ''">
          {{$t('password.savePassword')}}
      </button>
      <button
        class="md:hidden bg-b2c-red-300 text-white rounded p-2 px-3 mt-10"
        @click="saveNewPassword"
        :class="isLoading ? 'loader' : ''">
          {{$t('password.savePassword')}}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import MaterialInput from '@/components/graphics/MaterialInput.vue';
import MaterialLabel from '@/components/graphics/MaterialLabel.vue';
import DropdownArrow from '@/components/graphics/DropdownArrow.vue';

export default {
  data() {
    return {
      changePassword: false,
      updatePassword: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
      },
      isLoading: false,
    };
  },

  components: {
    MaterialInput,
    DropdownArrow,
    MaterialLabel,
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  methods: {
    saveNewPassword() {
      this.isLoading = true;
      axios.put(`/api/users/${this.user.id}/password`, this.updatePassword).then(({ data }) => {
        this.changePassword = false;
        this.updatePassword.oldPassword = '';
        this.updatePassword.newPassword = '';
        this.updatePassword.confirmNewPassword = '';
        this.isLoading = false;
        this.createNotification('success', data);
      }).catch(() => {
        this.isLoading = false;
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },
  },

};
</script>
